import React, { useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Button, Table, Upload, message } from 'antd'
import { DownloadOutlined, ImportOutlined } from '@ant-design/icons'
import { useLocalization } from '@contexts/LocalizationContext'
import PageLayout from '@layouts/PageLayout'
import { ExcelToJSON } from '@utils/excel'
import { growthLabels } from '@constants'
import { client } from '@utils/client'

const Create = () => {
  const params = useParams()
  const { t } = useLocalization()
  const history = useHistory()
  const [payload, setPayload] = useState([])

  const actions = {
    setPayload: (list) => {
      setPayload(list.map((item) => ({ sex: params.gender, ...item })))
    },
  }
  const customRequest = ({ file, onSuccess }) => {
    const xl2json = new ExcelToJSON(actions)
    xl2json.parseExcel(file)
    setTimeout(() => {
      onSuccess('ok')
    }, 0)
  }

  const handleSubmit = async () => {
    if (payload.length === 0) {
      message.warn('กรุณาอัปโหลดข้อมูลก่อน')
      return
    }
    try {
      const data = payload.map((item) => ({
        type: 'height',
        minWarningKey: 'P3',
        maxWarningKey: 'P97',
        ageMo: item.ageMo,
        sex: item.sex,
        data: {
          P3: item.P3,
          P25: item.P25,
          P50: item.P50,
          P75: item.P75,
          P97: item.P97,
        },
      }))
      await client.post('/standard', data)
      message.success('สำเร็จ')
      history.push('/height')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  const columns = [
    {
      title: t('height.listScreen.column.sex'),
      dataIndex: 'sex',
      key: 'sex',
      width: '20%',
    },
    {
      title: t('height.listScreen.column.age'),
      dataIndex: 'ageMo',
      key: 'ageMo',
      width: '20%',
    },
    ...growthLabels.map((item) => ({
      title: item.label,
      dataIndex: item.label,
      key: item.label,
      width: '10%',
    })),
  ]

  const data = payload

  return (
    <PageLayout
      title={t('height.createScreen.title')}
      extra={[
        <div key="extra" style={{ display: 'flex' }}>
          <Button
            key="download"
            type="link"
            href={`${process.env.PUBLIC_URL}/assets/growth-template.xlsx`}
            icon={<DownloadOutlined />}
          >
            {t('height.createScreen.downloadTemplate')}
          </Button>
          <Upload accept=".xlsx" customRequest={customRequest}>
            <Button icon={<ImportOutlined />} style={{ margin: '0 10px' }}>
              {t('height.createScreen.uploadExcel')}
            </Button>
          </Upload>
          <Button key="submit" type="primary" onClick={handleSubmit}>
            {t('height.createScreen.submit')}
          </Button>
        </div>,
      ]}
    >
      <Table columns={columns} dataSource={data} />
    </PageLayout>
  )
}

export default Create
